/* eslint-disable import/prefer-default-export */
export const SET_UF = 'SET_UF';
